<div class="menu_tabs_content_item" *ngFor="let item of archivedItems">
  <div class="menu_tabs_content_text">{{item.name}}</div>
  <div class="menu_tabs_content_link" (click)="onUnArchive(item)">Unarchive</div>
</div>
